'use client';
/** @jsxImportSource @emotion/react */

import type { ContainerProps } from '@mui/material/Container';

import MuiContainer from '@mui/material/Container';
/**
 * @deprecated Please use `Container` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-container-migration--container-migration-guide Migration guide}
 */
export type { ContainerProps };

/**
 * @deprecated Please use `Container` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-container-migration--container-migration-guide Migration guide}
 */
export const Container = MuiContainer;
